<template>
  <div class="f-toast">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.f-toast {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;

  background-color: var(--black-a90);
  /* Feedback / Bg blur + Drop shadow */

  box-shadow: 0px 8px 16px rgba(22, 22, 21, 0.25);
  backdrop-filter: blur(4px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 8px;

  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%;

  height: 56px;

  color: #ffffff;

  &.error {
    background-color: var(--statusNegative-a90);
  }
}
</style>